const init = () => {

  // Opening times toggle
  $('.opening-times').click(function (e) {
    e.preventDefault();
    $(this).toggleClass('active');
    $('.opening-times__details').toggle();
  });

   // Opening times toggle travelsphere
   $('.opening-timesTs').click(function (e) {
    e.preventDefault();
    $(this).toggleClass('activeTs');
    $('.opening-times__detailsTs').toggle();
  });

  // My Account button toggle
  $('.primary-nav__btn').click(function (e) {
    e.preventDefault();
    $('.my-account-button__items').toggle();
  });

  // My Account button toggle Travelsphere
  $('.primary-nav__btnTs').click(function (e) {
    e.preventDefault();
    $('.my-account-button__items').toggle();
  });
};

export {
  init
}